import { VerifiedDocument } from 'types/documentTypes';
import axiosInstance from './axiosInstance';


export const fetchCertificate = async () => {
  try {
    const response = await axiosInstance.get(`/documents/certificate-scolarite`);
    return response.data;
  } catch (error) {
    console.error('Error fetching certificate:', error);
    throw error;
  }
};

export const generateCertificate = async () => {
  try {
    const response = await axiosInstance.get(`/documents/generate/certificat-scolarite`);
    return response.data;
  } catch (error) {
    console.error('Error generating certificate:', error);
    throw error;
  }
};
export const getDocumentById = (id: string) =>
  axiosInstance.get<VerifiedDocument>(`/documents/verify/${id}`);
